<template>
    <div>
        <v-dialog
            v-model="open_modal"
            scrollable
            max-width="600"
            content-class="tw-rounded-3xl tw-w-full"
        >
            <v-card class="tw-rounded-3xl tw-border-0">
                <v-card-text class="tw-bg-gray-100 tw-py-6">
                    <EditorTipTap 
                        v-model="description"
                        :label="$t('bz2.registry.setting.payment.price_event_label')" 
                        :description="$t('bz2.registry.setting.payment.price_event_desc')" 
                    />
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <AppBtn type="button" color="transparent" @click="close">
                        {{ $t('app.cancel') }}
                    </AppBtn>
                    <AppBtn type="button" color="primary" icon="check" @click="save">
                        {{ $t('app.save') }}
                    </AppBtn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <AppBtn 
            type="button" 
            color="transparent-primary" 
            icon-center="addTextSlider" 
            fab 
            small 
            @click="open_modal = true" 
        />
    </div>
</template>
<script>
import EditorTipTap from '@/components/FormInputs/EditorTipTap.vue'
import AppBtn from '@/components/App/AppBtn.vue'
export default {
    components: {
        EditorTipTap,
        AppBtn,
    },
    props: {
        value: {
            type: String,
            default: '',
        },
    },
    data:() => ({
        open_modal: false,
    }),
    computed: {
        description: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val)
            },
        },
    },
    methods: {
        close() {
          this.open_modal = false
        },
        save() {
            this.open_modal = false
        },
    },
}
</script>